// Button hover wipe: a rounded fill slides in from the top and exits through
// the bottom. A clone of the label lives inside the fill in the wipe colour,
// so the text changes colour exactly where the fill covers it (a clean wipe,
// not a colour fade).
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = '.button:not(.button--tertiary), .shopify-challenge__button, .customer button, button.shopify-payment-button__button--unbranded';

  function target(event) {
    var el = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
    return el && !el.disabled && el.getAttribute('aria-disabled') !== 'true' ? el : null;
  }

  function ensureWipe(button) {
    var wipe = button.querySelector(':scope > .button__wipe');
    if (!wipe) {
      wipe = document.createElement('span');
      wipe.className = 'button__wipe';
      wipe.setAttribute('aria-hidden', 'true');
      wipe.appendChild(document.createElement('span')).className = 'button__wipe-inner';
      button.appendChild(wipe);
    }
    // Rebuild the label clone each time so it never goes stale.
    var copy = button.cloneNode(true);
    var stale = copy.querySelector('.button__wipe');
    if (stale) stale.remove();
    copy.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
    wipe.firstChild.innerHTML = copy.innerHTML;
  }

  document.addEventListener('mouseover', function (event) {
    var button = target(event);
    if (!button || button.contains(event.relatedTarget)) return;
    ensureWipe(button);
    button.classList.remove('is-wipe-out');
    button.classList.remove('is-wipe-in');
    // Force a reflow so the in-animation restarts on every hover.
    void button.offsetWidth;
    button.classList.add('is-wipe-in');
  });

  document.addEventListener('mouseout', function (event) {
    var button = target(event);
    if (!button || button.contains(event.relatedTarget)) return;
    button.classList.remove('is-wipe-in');
    void button.offsetWidth;
    button.classList.add('is-wipe-out');
  });

  document.addEventListener('animationend', function (event) {
    if (event.animationName === 'button-wipe-out' && event.target instanceof Element) {
      var button = event.target.closest(SELECTOR);
      if (button) button.classList.remove('is-wipe-out');
    }
  });
})();
